import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../Atoms/Icon';

const propTypes = exact({
  rating: PropTypes.number.isRequired,
});

function Rating(props) {
  const isInteger = Number.isInteger(props.rating);
  const fullStars = Math.floor(props.rating);
  const ghostStars = 5 - Math.ceil(props.rating);

  const fullStarsArray = [...Array(fullStars)].map((option, index) => ({ id: index }));
  const ghostStarsArray = [...Array(ghostStars)].map((option, index) => ({ id: index }));

  return (
    <div className="Rating">
      {fullStarsArray.map((star) => (
        <div className="Rating_column" key={`fullStar-${star.id}`}>
          <Icon id="star-full" />
        </div>
      ))}
      {!isInteger && (
        <div className="Rating_column">
          <Icon id="star-half" />
        </div>
      )}
      {ghostStarsArray.map((star) => (
        <div className="Rating_column" key={`ghostStar-${star.id}`}>
          <Icon id="star-empty" />
        </div>
      ))}
    </div>
  );
}

Rating.propTypes = propTypes;

export default Rating;
